module.exports = __webpack_public_path__ + "img/vertical_6_6_8003.67378b1d.png";